import { User } from '@supabase/supabase-js';

export const getFullName = (user?: User | null): string => user?.user_metadata.full_name ?? 'User';

export const getFirstName = (user?: User | null): string => getFullName(user).split(' ')[0];



export const getInitialsFromFullName = (fullName?: string): string =>
  fullName
    ? fullName
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map(chunk => chunk[0])
      .join('')
      .toUpperCase()
    : '';
    

export const getInitials = (user?: User | null): string =>
  getInitialsFromFullName(getFullName(user));

export const getEmail = (user?: User | null): string => user?.email ?? '';
